var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"automated-translation-label d-inline-flex"},[_c('span',{staticClass:"icon-automated d-inline-flex align-items-center mr-2"}),_vm._v("\n  "+_vm._s(_vm.$t('multilingual.automatedPageTranslations'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }